import React from 'react';
import { LoadingBars } from '@components/LoadingBars/LoadingBars';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { StandardModal } from '@components/main-components/modals/StandardModal';
import { etherscanForTransaction } from '@utils/helpers';

export const ProcessingModal = ({
  heading,
  transactionInfo,
}: {
  heading: string;
  transactionInfo: { txHash: string; chainId: number } | null;
}) => {
  const body = (
    <>
      <div className="mb-2 flex w-full justify-center">
        <LoadingBars height={undefined} />
      </div>
      <span className="mt-2 flex w-full justify-center font-base text-base-l font-semibold md:mt-4 md:text-base-xl">
        Processing...
      </span>
      <div className="mt-2 text-center text-[14px] md:mt-4 md:text-[16px]">
        <div className="font-normal leading-5 text-neutral700">
          {heading}

          {transactionInfo && (
            <div>
              View on{' '}
              <AccessibleLink
                absoluteUri={etherscanForTransaction({
                  transactionHash: transactionInfo.txHash,
                  chainId: transactionInfo.chainId,
                })}
                type="external"
                className="font-medium"
              >
                Etherscan
              </AccessibleLink>
            </div>
          )}
        </div>
      </div>
    </>
  );

  return <StandardModal body={body} preventClose />;
};
